import React from 'react';

const AiLoadingBar = () => (
	<div className="ignite-ai__loading" />
);

export default AiLoadingBar;
